'use client';

import { useEffect, useState } from 'react';

import { TImageTokenWithFile, TImagesDataById } from '@northladder/apis';
import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

import { DeviceImagesCaptureAndUpload } from '../DeviceImagesCaptureAndUpload';
import { DoneUploadingImagesCTA } from '../DoneUploadingImagesCTA';

interface IDevicesImagesListProps {
  imagesDataIds: string[];
  imagesDataById: TImagesDataById;
  onUpdateImage: (updatedImage: TImageTokenWithFile) => void;
  onClickDone: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Creates functionality for selecting, uploading and previewing the uploaded
 * image.
 */
export function DevicesImagesList({
  imagesDataIds,
  imagesDataById,
  onUpdateImage,
  onClickDone,
}: IDevicesImagesListProps) {
  const [hasPendingUpload, setHasPendingUpload] = useState(false);

  useEffect(() => {
    const updatedHasPendingUpload = Object.values(imagesDataById).find(
      (imageData) => imageData.status?.toLowerCase() !== 'completed'
    );
    setHasPendingUpload(!!updatedHasPendingUpload);
  }, [imagesDataById]);

  return (
    <main className="min-h-screen">
      <div className="mx-auto max-w-7xl px-4 pb-16 text-center sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-4xl flex-col items-center py-8">
          <h1 className="text-xl font-normal tracking-tight text-gray-700 sm:text-xl">
            <Text text={translations.instructions.title} />
          </h1>
          <p className="text-primary-900 mt-2 max-w-xl font-light ">
            <Text text={translations.instructions.subTitle} />
          </p>
        </div>

        <DeviceImagesCaptureAndUpload
          imagesDataById={imagesDataById}
          imagesDataIds={imagesDataIds}
          onUpdateImage={onUpdateImage}
        />

        <div className="flex justify-end">
          <DoneUploadingImagesCTA
            isEnabled={!hasPendingUpload}
            onClickDone={onClickDone}
          />
        </div>
      </div>
    </main>
  );
}
